import { Row, Col, Form, Button, Card, InputGroup } from 'react-bootstrap'
import ButtonSpinner from '../../components/common/ButtonSpinner'
import { AuthRequest } from '../../redux/slices/auth.slice'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Fragment, useState } from 'react'
import Images from '../../assets/js/images'
import { FiMail } from "react-icons/fi"

function Login() {
  const { t } = useTranslation()
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const { data: auth, loading } = useSelector(state => state.AuthSlice)
  // eslint-disable-next-line

  const handleSubmit = (e) => {
    e.preventDefault()
    const form = new FormData(e.target)
    const formData = Object.fromEntries(form)
    dispatch(AuthRequest({ data: formData, navigate }))
  }

  return (
    <Fragment>
      <div className="wrapper">
        {/* <div className="authentication-header"></div> */}
        <div className="section-authentication-signin d-flex align-items-center justify-content-center py-5 position-relative">
          {/* <div className='round-box1 position-absolute'></div> */}
          {/* <div className='round-box2 position-absolute'></div> */}
          <div className="container">
            <Row className='align-items-center'>
              <Col lg={6} className='text-center'>
                <img src={Images?.NewLogo} alt="logo icon" style={{ width: '200px' }} className='mx-auto' />
                <div style={{ backgroundImage: `url(${Images?.BgLogin})`, backgroundSize: 'cover' }} className='text-center'>
                  <div style={{ minHeight: '450px' }} className='position-relative'>
                    <img src={Images?.Car} className='position-absolute start-0' style={{ bottom: '70px', width: '500px' }} />
                  </div>
                </div>
              </Col>
              <Col lg={6}>
                <Row>
                  <Col sm={10} md={8} className='mx-auto'>
                    <Card className="card login-box">
                      <div className="card-body">
                        <div className="p-4 rounded">
                          <div className="text-center">
                            <h3 className="mb-4">{t('login')}</h3>
                          </div>
                          <div className="form-body">
                            <Form className="row g-3" onSubmit={handleSubmit} autoComplete="off">
                              <InputGroup className="mb-3">
                                <InputGroup.Text><FiMail /></InputGroup.Text>
                                <Form.Control
                                  type="email"
                                  name="email"
                                  id="inputEmailAddress"
                                  placeholder={t('enter_email')}
                                  autoComplete="off"
                                />
                              </InputGroup>
                              <InputGroup className="form-group position-relative" id="show_hide_password">
                                <InputGroup.Text className='text-decoration-underline align-items-center'>***</InputGroup.Text>
                                <Form.Control type={showPassword ? 'text' : 'password'} name="password" id="inputChoosePassword" placeholder={t('password')} /> <a type="button" onClick={() => { setShowPassword(!showPassword) }} className="bg-transparent position-absolute" style={{ top: '9px', right: '10px', zIndex: 99 }}>{showPassword ? <i className='bx bx-show'></i> : <i className='bx bx-hide'></i>}</a>
                              </InputGroup>
                              <div className='d-flex align-items-center justify-content-end'><Link to="/forgot-password" className='text-decoration-underline text-dark'>{t('forgot_password')} ?</Link></div>
                              <Col className="col-12">
                                <div className="d-grid">
                                  <Button type="submit" className="btn btn-primary d-flex align-items-center justify-content-center"> {t('login')} {loading && <ButtonSpinner />}</Button>
                                </div>
                              </Col>
                            </Form>
                          </div>
                        </div>
                      </div>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default Login
